import { render, staticRenderFns } from "./AdvertCampaignList.vue?vue&type=template&id=850857b4&scoped=true&"
import script from "./AdvertCampaignList.vue?vue&type=script&lang=js&"
export * from "./AdvertCampaignList.vue?vue&type=script&lang=js&"
import style0 from "./AdvertCampaignList.vue?vue&type=style&index=0&id=850857b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850857b4",
  null
  
)

export default component.exports